"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputStyles = void 0;

var _styledComponents = require("styled-components");

var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));

var InputStyles = {
  Base: (0, _styledComponents.css)(["font-family:inherit;box-sizing:border-box;padding:16px 8px;font-size:14px;font-weight:bold;line-height:16px;height:48px;transition:background-color 300ms,border-color 300ms;border:none;background-color:transparent;"]),
  Normal: (0, _styledComponents.css)(["background-color:#fff;border:1px solid ", ";border-radius:4px;"], _userflow["default"].colors.whiteLight),
  Error: (0, _styledComponents.css)(["border:1px solid #d0021b;background-color:#f9eaec;"]),
  Disabled: (0, _styledComponents.css)(["background-color:transparent;"]),
  Placeholder: (0, _styledComponents.css)(["font-weight:normal;color:", ";"], _userflow["default"].colors.frenchGray),
  Focus: (0, _styledComponents.css)(["outline:none;"]),
  Small: (0, _styledComponents.css)(["height:40px;"])
};
exports.InputStyles = InputStyles;